<template>
  <div class="mb-4">
    <Chart :options="chartOptions" />
  </div>
</template>
<script setup lang="ts">
import { defineProps, computed } from "vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import accessibilityInit from "highcharts/modules/accessibility"; // Import the accessibility module
import exportingInit from "highcharts/modules/exporting";

// Initialize the accessibility module
accessibilityInit(Highcharts);
// Initialize the exporting module
exportingInit(Highcharts);

const props = defineProps(["data"]);
const chartData = computed(() => {
  return props.data.map(item=> ({
    x: item.element,
    y: item.value
  }));
});
const chartOptions = {
  chart: {
    type: "column",
  },
  title: {
    text: "Sensitivity analysis (+/- 20%)",
  },
  xAxis: {
    categories: chartData.value.map(item=>item.x),
  },
  yAxis: {
    title: {
      text: "Minimum Selling Price (€)",
    },
  },
  series: [
    {
      name: "Scenario",
      data: chartData.value.map(item=>item.y)
    },
  ],
  exporting: {
    enabled: true,
  },
  plotOptions:{
        column:{
            dataLabels: {
              enabled: true,
              inside: false, // Set to true if you want labels inside the column
              format:'{y} €'
            },
        }
    },
  tooltip: {
    formatter: function () {
      // Customize the tooltip format here
      return `${this.x}: <b>${this.y} €</b>`;
    },
  },
  legend: {
    enabled: false, // Disable the legend
  },
};
</script>
